/**
 * Phase 26: canonical cycle string parser — CRM mirror.
 *
 * Verbatim duplicate of `artifacts/api-server/src/lib/period-cycle.ts`. The
 * api-server file is the reference source. Keep both files in sync — CRM
 * tsconfig path map cannot reach `artifacts/api-server/src/lib`, so we ship a
 * verbatim duplicate rather than restructure path maps.
 *
 * Accepts:
 *   - Legacy enums (Phase 24): Monthly, Quarterly, Six_Month, Yearly
 *   - New {n}_{Unit} pattern (Phase 26): 1_Month, 3_Month, 5_Hour, 7_Day, ...
 *
 * Zero rejection (value === 0) is an operator concern, not a parser concern
 * (per 26-RESEARCH.md Open Question).
 */

export type PeriodUnit = 'Hour' | 'Day' | 'Month';

export interface ParsedCycle {
  value: number;
  unit: PeriodUnit;
}

const LEGACY: Record<string, ParsedCycle> = {
  Monthly:   { value: 1,  unit: 'Month' },
  Quarterly: { value: 3,  unit: 'Month' },
  Six_Month: { value: 6,  unit: 'Month' },
  Yearly:    { value: 12, unit: 'Month' },
};

const NEW_PATTERN = /^([0-9]+)_(Hour|Day|Month)$/;

export function parsePeriodCycle(cycle: string): ParsedCycle {
  if (cycle in LEGACY) return LEGACY[cycle]!;
  const m = NEW_PATTERN.exec(cycle);
  if (!m) throw new Error(`Unparseable cycle string: ${cycle}`);
  return { value: parseInt(m[1]!, 10), unit: m[2]! as PeriodUnit };
}

export function formatPeriodCycle(value: number, unit: PeriodUnit): string {
  return `${value}_${unit}`;
}
